export default __webpack_public_path__ + "locales/tr/VersionHistory.json?hash=67e98e6dd845efb06ede4d1233d09ffb";